export const FETCH_ARTISTS = "FETCH_ARTISTS";
export const FETCH_SALES = "FETCH_SALES";
export const SET_ARTIST = "SET_ARTIST";
export const UPDATE_DISPLAY_ARTIST = "UPDATE_DISPLAY_ARTIST";
export const RESET_ARTIST_DISPLAY_STATE = "RESET_ARTIST_DISPLAY_STATE";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_DISPLAY_ARTISTS = "SET_DISPLAY_ARTISTS";
export const FETCH_DISPLAY_ARTIST = "FETCH_DISPLAY_ARTIST";
export const ASYNC_START = "ASYNC_START";
export const FETCH_DISPLAY_SALE = "FETCH_DISPLAY_SALE";



// WEBPACK FOOTER //
// ./src/actions/types.js